// The game's font (owner, 2026-09-29: Grandstander, picked with the dev font switcher). Texts
// that ask for the system font get it; deliberately different fonts (monospace code boxes, the
// Georgia quiz, cursive) keep theirs. Pure (node --test).
export const GAME_FONT = '"Grandstander", system-ui, -apple-system, "Segoe UI", sans-serif';

export function resolveFamily(requested) {
  const f = (requested ?? '').trim();
  if (!f || /^system-ui\b/.test(f) || /^-apple-system\b/.test(f)) return GAME_FONT;
  return f;
}
